// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-1deec271]{background:#000;color:#fff;font-size:.9rem}.separator[data-v-1deec271]{padding:0 1rem;position:relative}.separator[data-v-1deec271]:before{border-right:1px solid hsla(0,0%,100%,.3);bottom:0;content:\"\";height:100%;left:40%;position:absolute;top:0;transform:translateX(-50%);width:1px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
